import React from 'react'

const Footer = () => {
    return(
        <div className="main-footer">
            <p>&copy;{new Date().getFullYear()} npm start career | All Rights Reserved | Terms Of Service | Privacy</p>
        </div>
    )
}
  
export default Footer;